import React from 'react'

import { Slide } from '@material-ui/core'

const SlideUp = <U extends {}>(props: U) =>
  <Slide direction="up" {...props} />

export default SlideUp
try {
    // @ts-ignore
    SlideUp.displayName = "SlideUp";
    // @ts-ignore
    SlideUp.__docgenInfo = { "description": "", "displayName": "SlideUp", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/SlideUp/SlideUp.tsx#SlideUp"] = { docgenInfo: SlideUp.__docgenInfo, name: "SlideUp", path: "src/components/SlideUp/SlideUp.tsx#SlideUp" };
}
catch (__react_docgen_typescript_loader_error) { }